import { 
  dashMainTitleContent, 
  dashImageContent, 
  dashOverviewContent, 
  dashDetailsContent 
} from "../data/dashcontent";
import { 
  lipaLaterMainTitleContent, 
  lipaLaterImageContent, 
  lipaLaterOverviewContent, 
  lipaLaterDetailsContent 
} from "../data/lipaLaterContent";
import { 
  hustleSasaMainTitleContent, 
  hustleSasaImageContent, 
  hustleSasaOverviewContent, 
  hustleSasaDetailsContent 
} from "../data/hustleSasaContent";
import { 
  agrikoreMainTitleContent, 
  agrikoreImageContent, 
  agrikoreOverviewContent, 
  agrikoreDetailsContent 
} from "../data/agrikoreContent";

/**
 * Centralized portfolio content configuration
 * Maps project slugs to their respective content
 */
export const portfolioContent = {
  'dash': {
    mainTitle: dashMainTitleContent,
    image: dashImageContent,
    overview: dashOverviewContent,
    details: dashDetailsContent
  },
  'lipa-later': {
    mainTitle: lipaLaterMainTitleContent,
    image: lipaLaterImageContent,
    overview: lipaLaterOverviewContent,
    details: lipaLaterDetailsContent
  },
  'hustle-sasa': {
    mainTitle: hustleSasaMainTitleContent,
    image: hustleSasaImageContent,
    overview: hustleSasaOverviewContent,
    details: hustleSasaDetailsContent
  },
  'agrikore': {
    mainTitle: agrikoreMainTitleContent,
    image: agrikoreImageContent,
    overview: agrikoreOverviewContent,
    details: agrikoreDetailsContent
  }
};

/**
 * Get all available project slugs
 */
export const getAvailableProjects = () => Object.keys(portfolioContent);

/**
 * Check if a project exists
 */
export const projectExists = (slug) => slug in portfolioContent;

/**
 * Get content for a specific project
 */
export const getProjectContent = (slug) => portfolioContent[slug] || null;
